const zhCN = {
    title: '插件积分与使用量',
    description: '积分余额、Codex 实际消耗及文档维度统计',
    pricingFormulaNote: '积分扣减：按上游计费事件提供的实际费用（USD）乘以对应模型的积分/美元比例，每个 Run 汇总后向上取整。',
    config: {
        title: '全局配置',
        notConfigured: '尚未配置，请保存全局配置。',
        balanceSettingsTitle: '额度与拦截',
        balanceSettingsHint: '设置余额预警阈值和余额不足时的运行策略。',
        warningThreshold: '余额预警阈值（%）',
        blockInsufficient: '余额不足时禁止创建新 Run',
        creditGroupsTitle: '积分换算组',
        creditGroupsHint: '将多个模型归入同一换算组，组内共用积分/美元比例。',
        invalidPricingConfig: '积分组配置格式不正确，请检查配置后重试。',
        creditGroupName: '分组名称',
        creditGroupNamePlaceholder: '例如：标准组',
        groupModels: '组内模型',
        noCreditGroups: '暂无积分组，可添加后保存。',
        creditGroupValidation: {
            duplicateGroupId: '积分组 ID 不能重复。',
            duplicateModel: '同一模型不能重复归属积分组。',
            idInvalid: '积分组 ID 格式无效。',
            idRequired: '积分组 ID 不能为空。',
            modelsRequired: '每个积分组至少选择一个模型。',
            nameRequired: '积分组名称不能为空。',
            nameTooLong: '积分组名称不能超过 128 个字符。',
            ratioInvalid: '积分/美元比例必须是非负有限数值。',
        },
        selectModel: '搜索并选择模型',
        modelMissing: '当前模型列表未返回',
        noAvailableModels: '未获取到可用模型',
        modelsLoadFailed: '模型列表加载失败，已保存配置仍会保留。',
        retryModels: '重新加载',
        creditsPerUsd: '积分/美元',
        modelRoutingTitle: '模型与内核路由',
        modelRoutingHint: '按模型标签映射执行内核，插件用户仍只看到 auto。',
        autoRoutingTitle: 'Auto 模型路由',
        autoEnabled: '启用 auto 路由',
        resolvedModel: 'auto 对应实际模型',
        resolvedKernel: '对应内核',
        noKernel: '未分组',
        kernelGroups: '内核分组',
        savedPricingOnlyHint: '仅可选择已保存在积分组中的模型。',
        addModelToKernel: '添加模型',
        inactivePricingModel: '该模型尚未保存在积分组中，请先保存积分组。',
    },
    summary: {
        periodTokens: '当前筛选期 Token 消耗',
        periodHint: '仅统计筛选时间范围',
        availableCredits: '永久总积分余额',
        permanentCreditsHint: '永久积分余额',
        avgDocuments: '人均文档数',
        activeUsers: '位活跃用户',
        avgTokens: '人均 Token 消耗',
        cached: '缓存 Token',
        insufficientUsers: '余额不足用户',
        insufficientHint: '含停用、预警和超额',
        estimatedCost: '筛选期 Token 成本',
        unpricedUsage: '条未计价',
        allPriced: '全部流水已计价',
    },
    filters: {
        startAt: '开始时间',
        endAt: '结束时间',
        labels: '用户标签',
        search: '邮箱',
        lastWeek: '近一周',
        lastMonth: '近一月',
        periodTokens: 'Token 消耗',
        lifetimeTokens: '累计消耗',
        documentCount: '文档数',
        lastUsedAt: '最近使用时间',
        desc: '降序',
        asc: '升序',
    },
    table: {
        user: '用户',
        labels: '标签',
        documents: '文档数',
        consumed: '累计消耗',
        periodConsumed: '筛选期消耗',
        lifetime: '累计',
        available: '积分余额',
        usageRate: '使用率',
        usageAndCredits: '使用率与积分余额',
        creditsBalance: '积分余额',
        cachedTokens: '缓存 Token',
        estimatedCost: 'Token 成本',
        cacheRatio: '缓存占比',
        status: '状态',
        actions: '操作',
    },
    detail: {
        drawerTitle: '用户 Token 消耗明细',
        email: '邮箱',
        userId: '用户 ID',
        company: '公司',
        empty: '当前筛选期暂无文档消耗',
        documentListTitle: '写入文档明细',
        userAnalysis: '用户分析',
        documents: '文档数',
        avgPerDocument: '平均 Token/文档',
        avgPerChat: '平均 Token/会话',
        periodTotal: '筛选期总 Token',
        cacheRatio: '缓存 Token 占比',
        inputOutput: '输入 / 输出 Token',
        document: '文档',
        untitled: '未命名文档',
        chats: '会话数',
        runs: 'Run 数',
        tokens: 'Token 消耗',
        sessionListTitle: '会话明细',
        session: '会话',
        untitledChat: '未命名会话',
        model: '模型',
        inputTokens: '输入 Token',
        outputTokens: '输出 Token',
        cachedInputTokens: '缓存 Token',
        totalTokens: '总 Token',
        estimatedCost: 'Token 成本',
        emptySessions: '当前文档暂无 Token 会话',
        lastUsedAt: '最近消耗时间',
    },
    status: {
        normal: '正常',
        insufficient: '余额不足',
        exceeded: '已超额',
        blocked: '已停用',
    },
    adjust: {
        title: '用户 Token 配置调整',
        batchTitle: '批量调整用户配置',
        selectedUsers: '个已选用户',
        labels: '用户标签（选填，可输入创建）',
        labelOperation: '标签操作（选填）',
        labelAppend: '追加标签',
        labelRemove: '移除标签',
        labelReplace: '替换标签',
        noStatusChange: '不修改状态',
        status: '账户状态',
        remark: '备注（选填）',
        noChanges: '请至少修改一项配置',
    },
    backfill: {
        confirmTitle: '确认历史数据计价',
        confirmPrefix: '将对全部',
        confirmSuffix: '条未计价历史使用记录执行计价，与当前筛选条件无关。是否继续？',
        noCandidates: '没有需要计价的历史使用记录',
        completed: '历史计价完成：',
        priced: '已计价',
        skipped: '跳过',
    },
    actions: {
        save: '保存配置',
        search: '查询',
        reset: '重置',
        refresh: '刷新',
        viewDetails: '查看明细',
        expand: '展开明细',
        collapse: '收起明细',
        adjust: '配置调整',
        batchAdjust: '批量调整用户配置',
        backfillCosts: '一键计价历史数据',
        cancel: '取消',
        confirm: '确认',
        addCreditGroup: '添加积分组',
        remove: '移除',
        saveCreditGroups: '保存积分组',
        saveRouting: '保存模型路由',
    },
    messages: {
        loadFailed: '加载插件 Token 使用量失败',
        detailFailed: '加载文档明细失败',
        configLoadFailed: '加载插件 Token 配置失败',
        labelsLoadFailed: '加载用户标签失败',
        configSaved: '配置已保存',
        configSaveFailed: '保存插件 Token 配置失败',
        pricingSaved: '积分组已保存',
        pricingSaveFailed: '保存积分组失败',
        routingSaved: '模型与内核路由已保存',
        routingSaveFailed: '保存模型与内核路由失败',
        adjusted: '用户 Token 配置已保存',
        adjustFailed: '保存用户 Token 配置失败',
        batchAdjusted: '批量用户配置已保存',
        batchAdjustFailed: '保存批量用户配置失败',
        backfillCountFailed: '获取未计价历史记录数量失败',
        backfillFailed: '历史使用记录计价失败',
    },
};

const zhTW = {
    ...zhCN,
    title: '外掛積分與使用量',
    description: '積分餘額、Codex 實際消耗及文件維度統計',
    pricingFormulaNote: '積分扣減：以上游計費事件提供的實際費用（USD）乘以對應模型的積分／美元比例，每個 Run 彙總後無條件進位。',
    config: {
        ...zhCN.config,
        title: '全域設定',
        notConfigured: '尚未設定，請儲存全域設定。',
        warningThreshold: '餘額預警門檻（%）',
        blockInsufficient: '餘額不足時禁止建立新 Run',
        creditsPerUsd: '積分／美元',
    },
    summary: {
        ...zhCN.summary,
        availableCredits: '永久總積分餘額',
        permanentCreditsHint: '永久積分餘額',
        estimatedCost: '篩選期 Token 成本',
    },
    filters: {
        ...zhCN.filters,
        search: '信箱',
        lastWeek: '近一週',
        lastMonth: '近一個月',
        periodTokens: 'Token 消耗',
        lastUsedAt: '最近使用時間',
    },
    table: {
        ...zhCN.table,
        user: '使用者',
        labels: '標籤',
        documents: '文件數',
        periodConsumed: '篩選期消耗',
        lifetime: '累計',
        available: '積分餘額',
        usageRate: '使用率',
        usageAndCredits: '使用率與積分餘額',
        creditsBalance: '積分餘額',
        cachedTokens: '快取 Token',
        estimatedCost: 'Token 成本',
        cacheRatio: '快取占比',
        status: '狀態',
        actions: '操作',
    },
    detail: {
        ...zhCN.detail,
        drawerTitle: '使用者 Token 消耗明細',
        email: '信箱',
        userId: '使用者 ID',
        company: '公司',
        empty: '目前篩選期暫無文件消耗',
        documentListTitle: '寫入文件明細',
        userAnalysis: '使用者分析',
        documents: '文件數',
        avgPerDocument: '平均 Token/文件',
        avgPerChat: '平均 Token/會話',
        periodTotal: '篩選期總 Token',
        cacheRatio: '快取 Token 占比',
        document: '文件',
        untitled: '未命名文件',
        sessionListTitle: '會話明細',
        session: '會話',
        untitledChat: '未命名會話',
        inputTokens: '輸入 Token',
        outputTokens: '輸出 Token',
        cachedInputTokens: '快取 Token',
        totalTokens: '總 Token',
        estimatedCost: 'Token 成本',
        emptySessions: '目前文件暫無 Token 會話',
        lastUsedAt: '最近消耗時間',
    },
    actions: {
        ...zhCN.actions,
        save: '儲存設定',
        search: '查詢',
        reset: '重設',
        viewDetails: '查看明細',
        expand: '展開明細',
        collapse: '收起明細',
        adjust: '設定調整',
    },
    adjust: {
        ...zhCN.adjust,
        title: '使用者 Token 設定調整',
        labels: '使用者標籤（選填，可輸入建立）',
        status: '帳戶狀態',
        remark: '備註（選填）',
        noChanges: '請至少修改一項設定',
    },
};

const enUS = {
    title: 'Add-in Credits & Usage',
    description: 'Credit balances, actual Codex usage, and document-level metrics',
    pricingFormulaNote: 'Credit deduction: multiply the actual USD cost from upstream billing events by each model’s credits / USD ratio, then sum and round up once per Run.',
    config: {
        title: 'Global Configuration',
        notConfigured: 'Not configured. Save the global configuration to create it.',
        balanceSettingsTitle: 'Balance and blocking',
        balanceSettingsHint: 'Set the balance warning threshold and insufficient-balance behavior.',
        warningThreshold: 'Balance warning threshold (%)',
        blockInsufficient: 'Block new Runs when balance is insufficient',
        creditGroupsTitle: 'Credit conversion groups',
        creditGroupsHint: 'Group models that share the same credits / USD ratio.',
        invalidPricingConfig: 'Invalid credit-group configuration. Please check the configuration and retry.',
        creditGroupName: 'Group name',
        creditGroupNamePlaceholder: 'For example: Standard',
        groupModels: 'Models in group',
        noCreditGroups: 'No credit groups. Add one or save the empty list.',
        creditGroupValidation: {
            duplicateGroupId: 'Credit group IDs must be unique.',
            duplicateModel: 'A model cannot belong to more than one credit group.',
            idInvalid: 'Credit group ID format is invalid.',
            idRequired: 'Credit group ID is required.',
            modelsRequired: 'Select at least one model for every credit group.',
            nameRequired: 'Credit group name is required.',
            nameTooLong: 'Credit group name cannot exceed 128 characters.',
            ratioInvalid: 'Credits / USD must be a finite nonnegative number.',
        },
        selectModel: 'Search and select a model',
        modelMissing: 'Not in the current model list',
        noAvailableModels: 'No available models returned',
        modelsLoadFailed: 'Failed to load models. Saved configuration is preserved.',
        retryModels: 'Reload models',
        creditsPerUsd: 'Credits / USD',
        modelRoutingTitle: 'Model and kernel routes',
        modelRoutingHint: 'Map model tags to execution kernels; add-in users still only see auto.',
        autoRoutingTitle: 'Auto model route',
        autoEnabled: 'Enable auto route',
        resolvedModel: 'Resolved model for auto',
        resolvedKernel: 'Resolved kernel',
        noKernel: 'Unassigned',
        kernelGroups: 'Kernel groups',
        savedPricingOnlyHint: 'Only models saved in a credit group can be selected.',
        addModelToKernel: 'Add model',
        inactivePricingModel: 'This model is not saved in a credit group. Save credit groups first.',
    },
    summary: {
        periodTokens: 'Tokens in selected period',
        periodHint: 'Selected period only',
        availableCredits: 'Total permanent credits',
        permanentCreditsHint: 'Permanent credit balance',
        avgDocuments: 'Documents per user',
        activeUsers: 'active users',
        avgTokens: 'Tokens per user',
        cached: 'Cached tokens',
        insufficientUsers: 'Users needing attention',
        insufficientHint: 'Blocked, warning, or exceeded',
        estimatedCost: 'Token cost in period',
        unpricedUsage: 'unpriced entries',
        allPriced: 'All entries priced',
    },
    filters: {
        startAt: 'Start time',
        endAt: 'End time',
        labels: 'User labels',
        search: 'Email',
        lastWeek: 'Last 7 days',
        lastMonth: 'Last 30 days',
        periodTokens: 'Token usage',
        lifetimeTokens: 'Lifetime usage',
        documentCount: 'Documents',
        lastUsedAt: 'Last used time',
        desc: 'Descending',
        asc: 'Ascending',
    },
    table: {
        user: 'User',
        labels: 'Labels',
        documents: 'Documents',
        consumed: 'Lifetime usage',
        periodConsumed: 'Period usage',
        lifetime: 'Lifetime',
        available: 'Credit balance',
        usageRate: 'Usage rate',
        usageAndCredits: 'Usage rate & credit balance',
        creditsBalance: 'Credit balance',
        cachedTokens: 'Cached tokens',
        estimatedCost: 'Token cost',
        cacheRatio: 'Cache ratio',
        status: 'Status',
        actions: 'Actions',
    },
    detail: {
        drawerTitle: 'User Token Usage Details',
        email: 'Email',
        userId: 'User ID',
        company: 'Company',
        empty: 'No document usage in this period',
        documentListTitle: 'Written document details',
        userAnalysis: 'User analysis',
        documents: 'Documents',
        avgPerDocument: 'Avg tokens/document',
        avgPerChat: 'Avg tokens/chat',
        periodTotal: 'Period tokens',
        cacheRatio: 'Cached token ratio',
        inputOutput: 'Input / output tokens',
        document: 'Document',
        untitled: 'Untitled document',
        chats: 'Chats',
        runs: 'Runs',
        tokens: 'Token usage',
        sessionListTitle: 'Session details',
        session: 'Session',
        untitledChat: 'Untitled session',
        model: 'Model',
        inputTokens: 'Input tokens',
        outputTokens: 'Output tokens',
        cachedInputTokens: 'Cached tokens',
        totalTokens: 'Total tokens',
        estimatedCost: 'Token cost',
        emptySessions: 'No token-consuming sessions for this document',
        lastUsedAt: 'Last usage',
    },
    status: {
        normal: 'Normal',
        insufficient: 'Low balance',
        exceeded: 'Exceeded',
        blocked: 'Blocked',
    },
    adjust: {
        title: 'Configure User Token Account',
        batchTitle: 'Batch Configure User Accounts',
        selectedUsers: 'users selected',
        labels: 'User labels (optional, custom values allowed)',
        labelOperation: 'Label operation (optional)',
        labelAppend: 'Append labels',
        labelRemove: 'Remove labels',
        labelReplace: 'Replace labels',
        noStatusChange: 'Do not change status',
        status: 'Account status',
        remark: 'Remark (optional)',
        noChanges: 'Change at least one configuration value',
    },
    backfill: {
        confirmTitle: 'Confirm historical pricing',
        confirmPrefix: 'Price all',
        confirmSuffix: 'unpriced historical usage records, independent of the current filters. Continue?',
        noCandidates: 'There are no historical usage records awaiting pricing',
        completed: 'Historical pricing completed:',
        priced: 'priced',
        skipped: 'skipped',
    },
    actions: {
        save: 'Save configuration',
        search: 'Search',
        reset: 'Reset',
        refresh: 'Refresh',
        viewDetails: 'View details',
        expand: 'Show details',
        collapse: 'Hide details',
        adjust: 'Configure',
        batchAdjust: 'Batch configure users',
        backfillCosts: 'Price historical usage',
        cancel: 'Cancel',
        confirm: 'Confirm',
        addCreditGroup: 'Add credit group',
        remove: 'Remove',
        saveCreditGroups: 'Save credit groups',
        saveRouting: 'Save model routes',
    },
    messages: {
        loadFailed: 'Failed to load add-in token usage',
        detailFailed: 'Failed to load document details',
        configLoadFailed: 'Failed to load add-in token configuration',
        labelsLoadFailed: 'Failed to load user labels',
        configSaved: 'Configuration saved',
        configSaveFailed: 'Failed to save add-in token configuration',
        pricingSaved: 'Credit groups saved',
        pricingSaveFailed: 'Failed to save credit groups',
        routingSaved: 'Model and kernel routes saved',
        routingSaveFailed: 'Failed to save model and kernel routes',
        adjusted: 'User token configuration saved',
        adjustFailed: 'Failed to save user token configuration',
        batchAdjusted: 'Batch user configuration saved',
        batchAdjustFailed: 'Failed to save batch user configuration',
        backfillCountFailed: 'Failed to load the unpriced historical usage count',
        backfillFailed: 'Failed to price historical usage records',
    },
};

const jaJP = {
    ...enUS,
    title: 'アドインのクレジットと使用量',
    description: 'クレジット残高、Codex の実使用量、文書別統計',
    pricingFormulaNote: 'クレジット控除：上流の課金イベントの実料金（USD）に各モデルのクレジット／USD 比率を掛け、Run ごとに合計して切り上げます。',
    config: {
        ...enUS.config,
        title: 'グローバル設定',
        notConfigured: '未設定です。グローバル設定を保存してください。',
        warningThreshold: '残高警告しきい値（%）',
        blockInsufficient: '残高不足時に新規 Run を禁止',
        creditsPerUsd: 'クレジット／USD',
    },
    summary: {
        ...enUS.summary,
        availableCredits: '永久クレジット残高',
        permanentCreditsHint: '永久クレジット残高',
        estimatedCost: '期間内の Token コスト',
    },
    filters: {
        ...enUS.filters,
        search: 'メールアドレス',
        lastWeek: '直近 7 日間',
        lastMonth: '直近 30 日間',
        periodTokens: 'Token 消費量',
        lastUsedAt: '最終使用時刻',
    },
    table: {
        ...enUS.table,
        user: 'ユーザー',
        labels: 'ラベル',
        documents: '文書数',
        periodConsumed: '期間内の消費',
        lifetime: '累計',
        available: 'クレジット残高',
        usageRate: '使用率',
        usageAndCredits: '使用率とクレジット残高',
        creditsBalance: 'クレジット残高',
        cachedTokens: 'キャッシュ Token',
        estimatedCost: 'Token コスト',
        cacheRatio: 'キャッシュ比率',
        status: '状態',
        actions: '操作',
    },
    detail: {
        ...enUS.detail,
        drawerTitle: 'ユーザー Token 消費の詳細',
        email: 'メールアドレス',
        userId: 'ユーザー ID',
        company: '会社',
        empty: '選択期間に文書の消費はありません',
        documentListTitle: '書き込み文書の詳細',
        userAnalysis: 'ユーザー分析',
        documents: '文書数',
        avgPerDocument: '文書あたり平均 Token',
        avgPerChat: '会話あたり平均 Token',
        periodTotal: '期間内 Token',
        cacheRatio: 'キャッシュ Token 比率',
        document: '文書',
        untitled: '無題の文書',
        chats: '会話数',
        runs: 'Run 数',
        tokens: 'Token 消費',
        sessionListTitle: '会話の詳細',
        session: '会話',
        untitledChat: '無題の会話',
        model: 'モデル',
        inputTokens: '入力 Token',
        outputTokens: '出力 Token',
        cachedInputTokens: 'キャッシュ Token',
        totalTokens: '合計 Token',
        estimatedCost: 'Token コスト',
        emptySessions: 'この文書には Token を消費した会話がありません',
        lastUsedAt: '最終消費時刻',
    },
    actions: {
        ...enUS.actions,
        save: '設定を保存',
        search: '検索',
        reset: 'リセット',
        viewDetails: '詳細を表示',
        expand: '詳細を表示',
        collapse: '詳細を閉じる',
        adjust: '設定を変更',
    },
    adjust: {
        ...enUS.adjust,
        title: 'ユーザー Token 設定の変更',
        labels: 'ユーザーラベル（任意・新規作成可）',
        status: 'アカウント状態',
        remark: '備考（任意）',
        noChanges: '少なくとも1つの設定を変更してください',
    },
};

export { enUS, jaJP, zhCN, zhTW };
